import React from 'react'
import { Link } from 'react-router-dom'
import { iBtnGov } from './ButtonGov'

interface iBtnGovLink extends iBtnGov {
  to: string
  openNewTab?: boolean
}

const ButtonGovLink = ({ to, openNewTab, variant, size, inversed, children, className, ...others }: iBtnGovLink) => {
  const classes = [className, 'gov-button']
  if (variant) {
    classes.push('gov-button--' + variant)
  }
  if (size) {
    classes.push('gov-button--' + size)
  }
  if (inversed) {
    classes.push('gov-button--inversed')
  }
  if (openNewTab) {
    classes.push('btnNoAfterIcon')
  }

  return (
    <Link className={classes.join(' ')} {...others} to={to} target={openNewTab ? '_blank' : undefined}>
      {children}
    </Link>
  )
}

export default ButtonGovLink
